import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { InsurancePolicy, PolicyStatus, PolicyWithStatus } from '@/types/insurance';
import { calculatePolicyStatus } from '@/lib/insurance-utils';

interface PolicyFilters {
  type?: string;
  status?: PolicyStatus;
}

export function useInsurancePolicies(filters?: PolicyFilters) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['insurance-policies', user?.id, filters],
    queryFn: async (): Promise<PolicyWithStatus[]> => {
      const { data, error } = await supabase
        .from('insurance_policies')
        .select('*')
        .eq('user_id', user!.id)
        .order('created_at', { ascending: false });

      if (error) throw error;

      let policies = (data as InsurancePolicy[]).map((policy) => ({
        ...policy,
        ...calculatePolicyStatus(policy),
      }));

      if (filters?.type) {
        policies = policies.filter((p) => p.policy_type === filters.type);
      }
      if (filters?.status) {
        policies = policies.filter((p) => p.status === filters.status);
      }

      return policies;
    },
    enabled: !!user,
  });
}
